import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7057e367"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "title pt-1"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "modal_content" }
const _hoisted_5 = { class: "modal_schedule-detail" }
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = { class: "modal_parent-detail mb-4" }
const _hoisted_8 = { class: "modal_support-layout" }

import { ref, watch } from 'vue'
import BarButton from '@/components/BarButton'
import BsDialog from '@/components/BsDialog/BsDialog.vue'
import locales from './CoachingSessionScheduleDetail.locales.en.json'
import XCircleIcon from '@/icons/XCircleIcon.vue'
import { CoachingSessionScheduleDetailViewModel } from './CoachingSessionScheduleDetail.interfaces'
import { DateTime } from 'luxon'
import { formatDisplaySchedule } from '@/utils/date'
import { Event as ClassroomEvent } from '@/types/api'
import { mapEventInstances } from '../CoachingSessionStore/CoachingSessionStore.utils'
import { useSessionRegistryStore } from '../SessionRegistryStore'
import { useClassroomStudentService } from '../ClassroomStudentService'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionScheduleDetail',
  props: {
    modelValue: {}
  },
  setup(__props: any) {

const props =
  __props

const eventDefaultSchedule = ref<string>('')
const eventStartDates = ref<DateTime[]>([])
const { sessionState } = useSessionRegistryStore()
const classroomStudentService = useClassroomStudentService()

watch(
  () => props.modelValue?.event,
  (newValue: ClassroomEvent) => {
    eventDefaultSchedule.value = formatDisplaySchedule(newValue)
    eventStartDates.value = mapEventInstances(newValue.meetingOccurrences.map(mo => mo.start), true)
  }
)

function GetDescription() {
  return eventDefaultSchedule.value
}

function formatDate(date: DateTime) {
  return date.toLocaleString(DateTime.DATE_MED).toUpperCase()
}

function isInThePast(date: DateTime) {
  return DateTime.now() > date
}

async function addToCalendarClicked() {
  await classroomStudentService.downloadCalendarInvite(props.modelValue!.event, sessionState.isLSAT)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BsDialog, {
    "class-names": "coaching-session-schedule-detail-dialog",
    "close-on-escape": "",
    "close-on-backdrop-click": "",
    "hide-footer": ""
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_unref(locales).title_session_schedule), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, [
          _createVNode(XCircleIcon)
        ], 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(locales).title_your_sessions) + ":", 1),
            _createTextVNode(" " + _toDisplayString(GetDescription()), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventStartDates.value, (instance, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("span", {
                  class: _normalizeClass({ muted: isInThePast(instance) })
                }, _toDisplayString(formatDate(instance)), 3)
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_unref(BarButton), {
          class: "button-dialog px-3 py-2",
          mode: "outline",
          onClick: addToCalendarClicked
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Add to Calendar ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})